import { useParams } from 'react-router-dom';
import { ProposalDetail } from './ProposalDetail';
import { Header, DashboardLayout } from '@/components/shared';
import { useTheme } from '@/contexts/ThemeContext';

export default function AgentProposalDetailPage() {
  const { proposalId } = useParams<{ proposalId: string }>();
  const { isDark } = useTheme();
  const userInfoStr = localStorage.getItem('user_info');
  const userInfo = userInfoStr ? JSON.parse(userInfoStr) : null;

  return (
    <div className="min-h-screen cgm-bg-primary">
      <Header userInfo={userInfo} />
      <DashboardLayout>
        {!proposalId ? (
          <div>Missing proposal id</div>
        ) : (
          <ProposalDetail proposalId={proposalId} />
        )}
      </DashboardLayout>
    </div>
  );
}
